// Package imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Custom imports
import api from "../../Api/feathers-client";

// Initial State
const initialState = {
  productData: null,
  language: -1,
};

// Action to fetch product data
export const fetchProduct = createAsyncThunk(
  "product/fetchProduct",
  async (queryObj, thunkAPI) => {
    const response = await api.service("load-product-json").find({
      query: queryObj,
    });
    console.log("response",response);
    return response;
  }
);

// Redux Slice for Product
const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProduct(state, { payload }) {
      state.productData = payload;
    },
    setLanguage(state, { payload }) {
      state.language = payload;
    },
  },
  extraReducers: {
    [fetchProduct.fulfilled]: (state, { payload }) => {
      state.productData = payload;
    },
  },
});

export const productSliceActions = productSlice.actions;

export default productSlice;
